import { Component, ViewChild } from '@angular/core';

import { SalesDashboardComponent } from '../sales-dashboard/sales-dashboard.component';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';

@Component({
  selector: 'app-iic-leads',
  imports: [
    SalesDashboardComponent,
    AdminDashboardComponent
  ],
  templateUrl: './iic-leads.component.html',
  styleUrls: ['../styles/leads.css', './iic-leads.component.css']
})
export class IicLeadsComponent {

  constructor() {
  }

  loggedInUser: any;
  userDepartment: any;
  loggedInUserName: any;
  userName: any;
  assistantUser: any;
  ngOnInit() {
    this.userDepartment = localStorage.getItem("department");
    this.loggedInUser = this.userDepartment === "ADMIN" || this.userDepartment === "MARKETING";
    this.assistantUser = this.userDepartment == "ASSISTANT-SALES"
    this.loggedInUserName = localStorage.getItem("username")

  }

}